export default {
  clients: [],
  total: 1
}